var MSGCode;
(function (MSGCode) {
    MSGCode[MSGCode["ERR001"] = 0] = "ERR001";
    MSGCode[MSGCode["ERR002"] = 1] = "ERR002";
    MSGCode[MSGCode["ERR003"] = 2] = "ERR003";
    MSGCode[MSGCode["ERR004"] = 3] = "ERR004";
    MSGCode[MSGCode["ALE001"] = 4] = "ALE001";
    MSGCode[MSGCode["SUC001"] = 5] = "SUC001";
    MSGCode[MSGCode["SUC002"] = 6] = "SUC002";
    MSGCode[MSGCode["CON001"] = 7] = "CON001";
    MSGCode[MSGCode["CON002"] = 8] = "CON002";
    MSGCode[MSGCode["CON003"] = 9] = "CON003";
    MSGCode[MSGCode["CON004"] = 10] = "CON004";
})(MSGCode || (MSGCode = {}));
export default MSGCode;
